// src/user/BillingPanel.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './BillingPanel.css';

const allProducts = [
  {
    id: 'lexmail',
    name: 'Lex Mail',
    description: 'Dily 1 minute Gmail call, so you dont miss anything.',
    currentPlan: 'Starter',
    nextBilling: '2025-07-15',
    icon: '/icons/lexmail.png',
  },
  {
    id: 'secman',
    name: 'Lex Call Angel',
    description: 'Pre-scheuled phone call with designed content and voice.',
    currentPlan: 'Starter',
    nextBilling: '2025-07-15',
    icon: '/icons/secman.png',
  },
  // 更多产品...
];

export default function BillingPanel() {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const filtered = allProducts.filter(p =>
    p.name.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="bp-wrapper">
      <h1 className="bp-title">Billing & Subscription</h1>
      <input
        className="bp-searchbox"
        type="text"
        placeholder="🔍 Search products..."
        value={query}
        onChange={e => setQuery(e.target.value)}
      />

      <div className="bp-card-grid">
        {filtered.map(product => (
          <div key={product.id} className="bp-card" onClick={() => navigate(`/billing/${product.id}`)}>
            <img src={product.icon} alt={product.name} className="bp-card-icon" />
            <h2 className="bp-card-title">{product.name}</h2>
            <p className="bp-card-desc">{product.description}</p>
            <p className="bp-card-plan">Plan: {product.currentPlan}</p>
            <p className="bp-card-date">Next Billing: {product.nextBilling}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
